module.exports = __webpack_public_path__ + "img/51717802.378a8fcd.png";